// Importa o React e hooks necessários
import React, { useEffect, useState } from 'react';
// Importa o CSS global da aplicação
import './App.css';
// Importa o CSS do Bootstrap para estilização dos componentes
import 'bootstrap/dist/css/bootstrap.min.css';
// Importa os componentes de roteamento do React Router
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// Importa as páginas/componentes principais da aplicação
import ResolucaoProblemas from './Pages/ResolucaoProblemas';
import TelaInicial from "./Pages/TelaInicial/TelaInicial";
import ReservaSala from './Pages/ReservaSala/ReservaSala';
import ChamadoADMForm from './Pages/ChamadoADM/chamadoAdm';
import TelaChamado from './Pages/ChamadoADM/telachamado'
import Comunicados from './Pages/Comunicados/comunicados';
import Clipping from './Pages/Comunicados/clipping'
import Adm from './Pages/Adm/adm';
import AssinaturaCard from './Pages/zTelaAssinatura/AssinaturaCard';

// Componente principal da aplicação
function App() {
  // Não há baseUrl neste arquivo, pois o roteamento é feito apenas entre componentes locais.
  // Caso precise usar baseUrl de API, utilize o padrão:
  // const baseUrl = "https://localhost:44304/api"; // DEV (localhost)
  // const baseUrl = "http://10.80.12.5:81/api"; // Produção

  return (
    // Router engloba todas as rotas da aplicação
    <Router>
      <Routes>
        {/* Define as rotas e os componentes que serão renderizados para cada caminho */}
        <Route path="/" element={<TelaInicial/>} />
        <Route path="/ResolucaoProblemas" element={<ResolucaoProblemas/>}/>
        <Route path='/ReservaSala' element={<ReservaSala/>}/>
        <Route path='/Chamado' element={<ChamadoADMForm/>}/>
        <Route path='/TelaChamado' element={<TelaChamado/>}/>
        <Route path='/Comunicados' element={<Comunicados/>}/>
        <Route path='/Clipping' element={<Clipping/>}/>
        <Route path='/AssinaturaCard' element={<AssinaturaCard/>}/>
      </Routes>
    </Router>
  );
}

export default App;